import { ICellRendererParams } from "@ag-grid-community/core";
import React, { useContext } from "react";
import { TimeZoneContext } from "utils/context";
import { getZonedTime } from "utils/utils";

export default function TimeCellRenderer(props: ICellRendererParams) {
    const [timeZone] = useContext(TimeZoneContext);
    return <>{getZonedTime(props.value, timeZone)}</>;
}
